import React from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AuthGuard } from "../App"; // Assuming AuthGuard is correctly implemented
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle, faSignOutAlt, faTimesCircle } from "@fortawesome/free-solid-svg-icons"; // Added relevant icons

const VacatePage = () => {
  const navigate = useNavigate();

  const handleVacate = () => {
    const token = localStorage.getItem("token");
    const userDataString = localStorage.getItem("user");
    const userData = JSON.parse(userDataString);
    const userId = userData.unique;

    // Basic validation before API call
    if (!token || !userId) {
      toast.error("Authentication details missing. Please log in again.");
      navigate("/"); // Redirect to login
      return;
    }

    toast.info("Submitting your vacate request...", { autoClose: 2000 });

    axios
      .post(
        `https://backend.inyumba.co.ke/iNyumba/vacatinghouse/users/${userId}`,
        {}, // Empty body as per original code
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        toast.success(response.data.response || "Vacate request submitted successfully!");
        localStorage.removeItem("specificPropertyId"); // Clear specific property ID if user vacates
        navigate("/user/myapartment"); // Redirect to reservations page after vacating
      })
      .catch((error) => {
        console.error("Error vacating house:", error);
        if (error.response && error.response.data && error.response.data.response) {
          toast.error(error.response.data.response);
        } else {
          toast.error("An error occurred while submitting your vacate request. Please try again.");
        }
      });
  };

  const handleCancel = () => {
    navigate("/user/myapartment"); // Navigate back to reservations page
  };

  return (
    <AuthGuard>
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-50 to-orange-100 p-4 sm:p-6 lg:p-8">
        
        <div className="max-w-xl w-full bg-white rounded-2xl shadow-xl hover:shadow-2xl transition-shadow duration-300 p-8 text-center space-y-6 animate-scale-in">
          <FontAwesomeIcon icon={faExclamationTriangle} className="text-orange-500 text-6xl mx-auto mb-4" />
          <h1 className="text-4xl font-extrabold text-gray-900 mb-2">Confirm Vacating Property</h1>
          <p className="text-gray-700 text-lg">
            Are you sure you want to proceed with vacating your property?
          </p>
          <p className="text-red-500 text-md font-medium mt-2">
            This action cannot be undone immediately and will initiate the property handover process.
          </p>
          <div className="flex justify-center space-x-8 pt-6">
            <button
              onClick={handleVacate}
              className="flex items-center space-x-2 bg-gradient-to-r from-red-600 to-rose-700 text-white px-8 py-4 rounded-full text-xl font-bold shadow-lg transition-all duration-300 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
            >
              <FontAwesomeIcon icon={faSignOutAlt} />
              <span>Yes, Vacate</span>
            </button>
            <button
              onClick={handleCancel}
              className="flex items-center space-x-2 bg-gray-200 text-gray-800 hover:bg-gray-300 px-8 py-4 rounded-full text-xl font-bold shadow-sm transition-all duration-300 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2"
            >
              <FontAwesomeIcon icon={faTimesCircle} />
              <span>No, Cancel</span>
            </button>
          </div>
        </div>
      </div>
    </AuthGuard>
  );
};

export default VacatePage;